var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subitem-container"},_vm._l((_vm.filteredSubItems),function(subItem){return _c('div',{key:subItem.title,staticClass:"subitem-title",class:{ 'subitem-title-hidden': subItem.hidden }},[_c('el-tooltip',{attrs:{"content":_vm.$t(
          `settings.permissions.role-dropdown.statuses.${_vm.computeState(
            subItem,
          )}`,
        ),"disabled":_vm.computeState(subItem) === 'full',"placement":"top"}},[_c('div',{staticClass:"state-indicator",class:_vm.computeState(subItem)})]),_vm._v(" "+_vm._s(_vm.$t(subItem.title))+" ")],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }